module.exports = __webpack_public_path__ + "img/green-check.1e4dde42.svg";